<span
  [@checkMarkFadeInOut]="icon"
  class="go-copy__content"
  (click)="copyStringToClipboard()">
  <go-icon
    [ngClass]="{ 'go-copy__icon--clicked': icon === 'check' }"
    [icon]="icon">
  </go-icon>
  <textarea class="go-copy__textarea" #copyText tabIndex="-1">{{text}}</textarea>
</span>
